export default __webpack_public_path__ + "static/media/reload-white.42a37a8e.svg";